// @flow
import React, {useState, useEffect} from "react";
import {css, StyleSheet} from "aphrodite";

import type {StyleDeclaration} from "aphrodite";

const SLOW_TRANSITION_SPEED = 7000;

const LogoPart = ({svgStyle, pathStyle, name, d, isMouseEnter, hoverLogoStyle}: {
    svgStyle: StyleDeclaration,
    pathStyle: StyleDeclaration,
    hoverLogoStyle: StyleDeclaration,
    isMouseEnter: boolean,
    name: string,
    d: string,
}) => {
    const [hasMounted, setHasMounted] = useState(false);
    const [useFastTransitionSpeed, setUseFastTransitionSpeed] = useState(false);

    useEffect(() => {
        setHasMounted(true);
        const timeout = setTimeout(() => {
            setUseFastTransitionSpeed(true);
        }, SLOW_TRANSITION_SPEED);
        return () => clearTimeout(timeout);
    },[]);

    return (
        <svg
            className={css([svgStyle, styles.svg])}
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 106.59 53.86"
        >
            <path
                className={css([
                    useFastTransitionSpeed ? styles.fastTransitionSpeed : styles.slowTransitionSpeed,
                    pathStyle,
                    !hasMounted && hoverLogoStyle,
                    useFastTransitionSpeed && isMouseEnter && hoverLogoStyle
                ])}
                data-name={name}
                d={d}
            />
        </svg>
    );
};

const styles = StyleSheet.create({
    fastTransitionSpeed: {
        transition: "all 1000ms ease",
    },
    slowTransitionSpeed: {
        transition: `all ${SLOW_TRANSITION_SPEED}ms ease`,
    },
    svg: {
        top: 0,
        left: 0,
        position: "absolute",
    },
});

export default LogoPart;
